export const UpdateMedicalConditions = (model) => {

  return $.post('Personnel/UpdateMedicalConditions',model)

}



// WEBPACK FOOTER //
// ./src/components/MedicalConditions/medicals.services.js